import React, { useState, FormEvent, useContext, useEffect } from 'react';
import { Segment, Form, Button, Grid, Input, Table, Select } from 'semantic-ui-react';
import { ITaskAssignment } from '../../../app/models/taskassignment';
import ProjectStore from '../../../app/stores/projectStore';
import { observer } from 'mobx-react-lite';
import { RootStoreContext } from '../../../app/stores/rootStore';

const AssignmentForm = () => {
  const rootStore = useContext(RootStoreContext);
  const {closeModal} = rootStore.modalStore;
  const projectStore = useContext(ProjectStore);
  const {
    taskassignmentRegistry,
    techniciansByName,
    taskassignmentsByCategory,
    assignTechnicianTask,
    loadTaskAssignments,
    submitting
  } = projectStore;

  // useEffect(() => {
  //   loadTechnicians();
  //   loadCertificates();

  //   return () => {
  //     fileRegistry.clear();
  //   };
  // }, []);

  const [technician, setTechnician] = useState({
    technicianEmail: '',
    remark: ''
  });
 
  const [taskchecked, setTaskChecked] = useState(new Map());

  const technicianOptions = techniciansByName.map(function (tech) {
    var option = { "key": tech.id, "text": tech.name, "value": tech.email }
    return option;
  }
  );

  const handleSubmit = () => {
    let techniciantasks: ITaskAssignment[] = new Array();
    let projectId = '';
    taskassignmentsByCategory.map(task => {
      let techniciantask: ITaskAssignment =
    {
      id : '0',
      createdAt: task.createdAt,
      updatedAt: task.updatedAt,
      projectId: task.projectId,
      itemName: task.itemName,
      itemDescription: task.itemDescription,
      itemCategory: task.itemCategory,
      technicianEmail: technician.technicianEmail,
      brightenCode: task.brightenCode,
      remark: technician.remark
    };
    projectId = task.projectId;
      const selecttask = taskchecked.get(task.id);
      if (selecttask === true)
      {
        techniciantask.id = task.id;
        techniciantasks.push(techniciantask);
      };
      
    })
    if(techniciantasks.length !== 0) 
    assignTechnicianTask(techniciantasks).then(() => loadTaskAssignments(projectId)).then(() => closeModal());
  };


  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setTechnician({ ...technician, [name]: value });
  };

  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
        <Form.Field inline >
                <label>Name</label>
                <Select
                  required
                  onChange={(e, { name, value }) => setTechnician({ ...technician, [name]: value })}
                  options={technicianOptions}
                  search
                  name='technicianEmail'
                  placeholder='Name'/>
              </Form.Field>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Select</Table.HeaderCell>
              <Table.HeaderCell>Item Name</Table.HeaderCell>
              <Table.HeaderCell>Item Category</Table.HeaderCell>
              <Table.HeaderCell>Item Description</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {taskassignmentsByCategory.map((taskassignment) => (
              (taskassignment.technicianEmail === null || taskassignment.technicianEmail === '')     &&    
              <Table.Row key={taskassignment.id}>
                <Table.Cell>
                <Form.Checkbox
            // label={certificate.name}
            checked={taskchecked.get(taskassignment.id)}
            onChange={(e, { checked }) => {
              setTaskChecked(taskchecked => taskchecked.set(taskassignment.id, checked)); 
            }}
            name={taskassignment.id}
          />
                </Table.Cell>
                <Table.Cell>
                   {taskassignment.itemName}
                </Table.Cell>
                <Table.Cell>
                {taskassignment.itemCategory}
                </Table.Cell>
                <Table.Cell>{taskassignment.itemDescription}</Table.Cell>
              </Table.Row> 
            ))}
          </Table.Body>
        </Table>
        {/* <Grid>
        <Grid.Column width={5} as={Segment}>
         <h5> Enable Skill: </h5>
        {certificatesByName.map(certificate => (
          (certificate.category === 'Enable Skill') && <Form.Checkbox
            label={certificate.name}
            checked={certchecked.get(certificate.id)}
            onChange={(e, { checked }) => {
              setCertificateChecked(certchecked => certchecked.set(certificate.id, checked)); 
              if (certchecked.get(certificate.id) === undefined || certchecked.get(certificate.id)===true)
              openModal(
                <Form.Group>
                <Input
                  label='Expiry Date'
                  onChange={(e, { value }) => setExpiryDate(expirydate => expirydate.set(certificate.id, value))}
                  name='expiryDate'
                  type='date'
                  placeholder='Expiry Date'
                />
                </Form.Group>
              )
            }}
            name={certificate.id}
          />
        ))}
        </Grid.Column>
        
        <Grid.Column width={2} as={Segment}>
        <h5> Soft Skill: </h5>
        {certificatesByName.map(certificate => (
          (certificate.category === 'Soft Skill') && <Form.Checkbox
            label={certificate.name}
            checked={certchecked.get(certificate.id)}
            onChange={(e, { checked }) => {
              setCertificateChecked(certchecked => certchecked.set(certificate.id, checked)); 
              if (certchecked.get(certificate.id) === undefined || certchecked.get(certificate.id)===true)
              openModal(
                <Form.Group>
                <Input
                  label='Expiry Date'
                  onChange={(e, { value }) => setExpiryDate(expirydate => expirydate.set(certificate.id, value))}
                  name='expiryDate'
                  type='date'
                  placeholder='Expiry Date'
                />
                </Form.Group>
              )
            }}
            name={certificate.id}
          />
        ))}
        </Grid.Column>
        <Grid.Column width={2} as={Segment}>
        <h5> Induction:</h5>
        {certificatesByName.map(certificate => (
          (certificate.category === 'Induction') && <Form.Checkbox
            label={certificate.name}
            checked={certchecked.get(certificate.id)}
            onChange={(e, { checked }) => {
              setCertificateChecked(certchecked => certchecked.set(certificate.id, checked)); 
              if (certchecked.get(certificate.id) === undefined || certchecked.get(certificate.id)===true)
              openModal(
                <Form.Group>
                <Input
                  label='Expiry Date:'
                  onChange={(e, { value }) => setExpiryDate(expirydate => expirydate.set(certificate.id, value))}
                  name='expiryDate'
                  type='date'
                  placeholder='Expiry Date'
                />
                </Form.Group>
              )
            }}
            name={certificate.id}
          />
        ))}
        </Grid.Column>
        <Grid.Column width={2} as={Segment}>
        <h5>  License: </h5>
        {certificatesByName.map(certificate => (
          (certificate.category === 'License') && <Form.Checkbox
            label={certificate.name}
            checked={certchecked.get(certificate.id)}
            onChange={(e, { checked }) => {
              setCertificateChecked(certchecked => certchecked.set(certificate.id, checked)); 
              if (certchecked.get(certificate.id) === undefined || certchecked.get(certificate.id)===true)
              openModal(
                <Form.Group>
                <Input
                  label='Expiry Date'
                  onChange={(e, { value }) => setExpiryDate(expirydate => expirydate.set(certificate.id, value))}
                  name='expiryDate'
                  type='date'
                  placeholder='Expiry Date'
                />
                </Form.Group>
              )
            }}
            name={certificate.id}
          />
        ))}
        </Grid.Column>
        <Grid.Column width={3} as={Segment}>
        <h5> Certificate: </h5>
        {certificatesByName.map(certificate => (
          (certificate.category === 'Certificate') && <Form.Checkbox
            label={certificate.name}
            checked={certchecked.get(certificate.id)}
            onChange={(e, { checked }) => {
              setCertificateChecked(certchecked => certchecked.set(certificate.id, checked)); 
              if (certchecked.get(certificate.id) === undefined || certchecked.get(certificate.id)===true)
              openModal(
                <Form.Group>
                <Input
                  label='Expiry Date'
                  onChange={(e, { value }) => setExpiryDate(expirydate => expirydate.set(certificate.id, value))}
                  name='expiryDate'
                  type='date'
                  placeholder='Expiry Date'
                />
                </Form.Group>
              )
            }}
            name={certificate.id}
          />
        ))}
        </Grid.Column>
        <Grid.Column width={2} as={Segment}>
        <h5>  Police Check: </h5>
        {certificatesByName.map(certificate => (
          (certificate.category === 'Police Check') && <Form.Checkbox
            label={certificate.name}
            checked={certchecked.get(certificate.id)}
            onChange={(e, { checked }) => {
              setCertificateChecked(certchecked => certchecked.set(certificate.id, checked)); 
              if (certchecked.get(certificate.id) === undefined || certchecked.get(certificate.id)===true)
              openModal(
                <Form.Group>
                <Input
                  label='Expiry Date'
                  onChange={(e, { value }) => setExpiryDate(expirydate => expirydate.set(certificate.id, value))}
                  name='expiryDate'
                  type='date'
                  placeholder='Expiry Date'
                />
                </Form.Group>
              )
            }}
            name={certificate.id}
          />
        ))}
        </Grid.Column>
        </Grid>*/}
        <Form.Input
          label='Remark'
          onChange={handleInputChange}
          name='remark'
          placeholder='Remark'
          value={technician.remark}
        />
        <Button
          loading={submitting}
          floated='right'
          positive
          type='submit'
          content='Submit'
        />
        <Button
          onClick={() => closeModal()}
          floated='right'
          type='button'
          content='Cancel'
        /> 
        
      </Form>
    </Segment>
  );
};

export default AssignmentForm;
